<template>
  <div class="card" id="Card" style="direction: rtl">
    <div class="card-header">
      <h3 class="card-title">اطلاعات مسیر خط</h3>
    </div>
    <div class="card-body">
     <CTabs >
          <CTab title="ارسال کامند" active>
            <CDataTable
                :hover="true"
                :border="true"
                
                :striped="true"
                :loading="$store.state.InlineLoading.Trajectory_FleetMustChange"
                :small="true"
                
                :items="$store.state.Trajectory_FleetMustChange.RequestResponse"
                :fields="fieldObject"
                :fixed="true"
                :items-per-page="10"
                pagination
                style="float: right;width: 100%;overflow: hidden;margin-top: 20px;direction: rtl;"
                :noItemsView="{ noResults: 'چیزی یافت نشد.', noItems: 'چیزی برای نمایش وجود ندارد.' }"

            >
              <template #Rows="{item,index}">
                  <td >
                      {{index+1}}
                  </td>
              </template>
              <template #Command="{item,index}">
                  <td style="font-size: 16px">
                      <CButton   color="primary" @click="GetInformation(item)" >دریافت مجدد اطلاعات</CButton>
                  </td>
              </template>
            </CDataTable>
          </CTab>
          <CTab title="همه" >
            <CDataTable
                :hover="true"
                :border="true"
                
                :striped="true"
                :loading="$store.state.InlineLoading.Trajectory_FleetMustChangeALL"
                :small="true"
                
                :items="$store.state.Trajectory_FleetMustChangeALL.RequestResponse"
                :fields="fieldObject"
                :fixed="true"
                :items-per-page="10"
                pagination
                style="float: right;width: 100%;overflow: hidden;margin-top: 20px;direction: rtl;"
                :noItemsView="{ noResults: 'چیزی یافت نشد.', noItems: 'چیزی برای نمایش وجود ندارد.' }"

            >
              <template #Rows="{item,index}">
                  <td >
                      {{index+1}}
                  </td>
              </template>
              <template #Command>
                  <td style="font-size: 16px">
                     {{'-'}}
                  </td>
              </template>
            </CDataTable>
          </CTab>
     </CTabs>


    </div>

  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: "Cart",
  data(){
    return {
     
      fieldObject:[{key:'Rows',label:'ردیف'},{key:'DeviceID',label:'شناسه دستگاه'},{key:'Version',label:'ورژن دستگاه'},{key:'FleetName',label:'نام خط (فعلی)'},{key:'CurrentFleetID',label:'(فعلی)شناسه خط'},{key:'FleetID',label:'(در دستگاه)شناسه خط'},{key:'CurrVehicleName',label:'نام خودرو'},{key:'Command',label:'دستورات'}],
    
    }
  },
  computed:{
    ReadCommands_Add(){
        return this.$store.state.Commands_Add;
    },
  },
  watch:{
    ReadCommands_Add(res){
         if(res.Status!==undefined){
              if(res.Status){
                  if(res.RequestResponse[0].Message==='Successfully!'){
                      this.$store.commit('ShowToast',{type:'success',message:'عملیات با موفقیت انجام شد.'})
                  }
                  
              }
          }
    },
  },
  mounted() {
    this.Trajectory_FleetMustChange();
    this.Trajectory_FleetMustChangeALL();
  },
  methods: {
    Trajectory_FleetMustChange(){
        this.$store.commit('Trajectory_FleetMustChange',{
            UserID:1,
           
        }); 
    },
    Trajectory_FleetMustChangeALL(){
        this.$store.commit('Trajectory_FleetMustChangeALL',{
            UserID:1,
           
        }); 
    },
    GetInformation(item){
        this.$store.commit('Trajectory_FleetMustChange',{
            UserID:1,
        }); 
    },
    GetInformation(item){
        var ts=Vue.moment().format('YYYY-MM-DD HH:mm:ss');
        var ts1=Vue.moment(ts, "YYYY-MM-DD HH:mm:ss").format("YYYY_MM_DD_HH_mm_ss");
        this.$store.commit('Commands_Add',{

            DeviceID:item.DeviceID,
            UserID:1,
            CommandTime:ts1,
            Tag:item.Tag,
            Command:"$Command;ChangeFleet;"+item.Tag+";"+item.CurrentFleetID,
        }); 
    }
  }
}
</script>

<style scoped>

</style>